import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53c0a42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spacer" }
const _hoisted_2 = { class: "wave" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 320",
  style: {"display":"block"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#1F1E05",
  "fill-opacity": "1",
  d: "M0,0L80,21.3C160,43,320,85,480,85.3C640,85,800,43,960,21.3C1120,0,1280,0,1360,0L1440,0L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z",
  style: {"--darkreader-inline-fill":"#007acc"},
  "data-darkreader-inline-fill": ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = { class: "footer__container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__container-element" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Contact Us"),
  /*#__PURE__*/_createElementVNode("p", null, "E-mail: angie.project.2023@gmail.com"),
  /*#__PURE__*/_createElementVNode("p", null, "Phone: +40723684262")
], -1))
const _hoisted_11 = { class: "footer__container-element" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Follow Us", -1))
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = {
  href: "https://www.facebook.com/profile.php?id=61553343279250&sk=about_details",
  target: "_blank"
}
const _hoisted_15 = {
  href: "https://www.instagram.com/angie._.project/",
  target: "_blank"
}
const _hoisted_16 = {
  href: "https://www.linkedin.com/in/angie-project-a7398929b/",
  target: "_blank"
}
const _hoisted_17 = { class: "footer__container-element" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2023-1-RO01-KA220-HED-000158031", -1))
const _hoisted_20 = { class: "footer__container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__container-element" }, [
  /*#__PURE__*/_createElementVNode("p", null, "© 2023 All rights reserved.")
], -1))
const _hoisted_22 = { class: "footer__container-element" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__container-element" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "disclaimer" }, " Funded by the European Union. The views and opinions expressed, however, belong solely to the author(s) and do not necessarily reflect the views and opinions of the European Union or the National Agency for Community Programs in the Field of Education and Vocational Training (ANPCDEFP). Neither the European Union nor ANPCDEFP can be held responsible for them. ")
], -1))

import ivyLeft from "@/assets/images/footer/ivy_left.png";
import ivyRight from "@/assets/images/footer/ivy_right.png";
import erasmus_logo from "@/assets/images/footer/erasmus_logo.png";
import angie_logo from "@/assets/images/footer/angie_logo.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "ivyLeft",
        src: _unref(ivyLeft),
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        class: "ivyRight",
        src: _unref(ivyRight),
        alt: ""
      }, null, 8, _hoisted_4),
      (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", _hoisted_14, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-facebook")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-instagram")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-linkedin")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("img", {
            src: _unref(erasmus_logo),
            alt: "erasmus_logo"
          }, null, 8, _hoisted_18),
          _hoisted_19
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("img", {
            src: _unref(angie_logo),
            alt: "angie_logo",
            class: "logo"
          }, null, 8, _hoisted_23)
        ])
      ]),
      _hoisted_24
    ])
  ]))
}
}

})